import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Box, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import { observer } from 'mobx-react-lite';
const StyledSelect = styled(Select)(({ theme }) => ({
    width: 170,
    height: 34,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: '22px',
    fontSize: theme.typography.caption.fontSize,
    lineHeight: 2,
    fontWeight: theme.typography.fontWeightBold,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    '&:hover': {},
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '&:focus-visible': {
        border: 'none',
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.text.secondary,
    },
    '& .MuiSelect-select': {
        paddingLeft: '44px',
        '& .MuiPaper-root': {
            background: theme.palette.primary.main,
        },
    },
}));
const CustomSelect = ({ option, options, setOption, startIcon, iconStyle, customStyle, idField = 'id', labelField = 'name', }) => (_jsxs(Box, { sx: { position: 'relative', width: customStyle.width }, children: [_jsx(Box, { sx: {
                position: 'absolute',
                top: '5px',
                left: '15px',
            }, children: startIcon || (_jsx(DoneIcon, { fontSize: "small", sx: { color: 'text.secondary', ...iconStyle } })) }), _jsx(StyledSelect, { labelId: "demo-simple-select-label", id: "demo-simple-select", IconComponent: KeyboardArrowDownIcon, value: option || '', MenuProps: {
                sx: {
                    '& .MuiPaper-root': {
                        background: (theme) => theme.palette.background.paper,
                        '&>ul': {
                            '&>li': {
                                color: (theme) => theme.palette.text.primary,
                            },
                        },
                    },
                },
            }, 
            //   inputProps={{
            //     sx: {
            //       '& .MuiPaper-root': {
            //         background: 'red',
            //         color: 'white',
            //       },
            //     },
            //   }}
            // @ts-ignore
            onChange: (e) => (setOption(options.find(((o) => o === e.target.value)))), sx: { ...customStyle }, children: options.map((o) => _jsx(MenuItem, { value: o, children: o[labelField] }, o[idField])) })] }));
CustomSelect.defaultProps = {
    startIcon: null,
    iconStyle: {},
    customStyle: {},
    idField: 'id',
    labelField: 'name',
};
export default observer(CustomSelect);
//# sourceMappingURL=CustomSelect.js.map